// extracted by mini-css-extract-plugin
export default {"photoWithLabel":"title-photo_photoWithLabel_t5zFr"};